import {CheckoutOrder} from "@apps/checkout/interfaces";
import {PartialOrder} from "@apps/daily-menu/interfaces";

import {ConversionItem} from "@globals/config/eventUtils";

/**
 * @param orders - List of orders to extract items;
 * @returns List of all items in orders for conversion GA event;
 */
export const getOrdersItems = (
  orders?: PartialOrder[] | CheckoutOrder[]
): ConversionItem[] => {
  return (
    orders
      ?.map((order) => {
        return order.order_items.map((item) => {
          return {
            item_id: item.id.toString(),
            item_name: "name" in item ? item.name : item.item,
            quantity: item.count,
          };
        });
      })
      .flat() ?? []
  );
};
